import { addMessages } from '@hana/i18n';

// Chuỗi Booking qua tin nhắn. Mã nghiệp vụ (BKG, ROD, PIC, Message-ID), tên riêng, dữ liệu mẫu không dịch.
addMessages('vi', {
  'bmsg.viewLabel': 'Góc nhìn · phím 1 / 2',
  'bmsg.tabReq': 'Yêu cầu 5',
  'bmsg.tabVessel': 'Tàu 6',
  'bmsg.coordGroup': 'Điều phối mail chung',
  'bmsg.coord': 'Điều phối',
  'bmsg.schedule': 'Lịch',
  'bmsg.scheduleTip': 'Lịch luân phiên T2–T7',
  'bmsg.title': 'Yêu cầu booking',
  'bmsg.load': 'Tải BKG',
  'bmsg.tasks': 'Việc',
  'bmsg.notif': 'Thông báo',
  'bmsg.more': 'Thao tác khác',
  'bmsg.bulkRod': 'Gửi ROD hàng loạt',
  'bmsg.bulkRodTip': 'Gửi ROD cho các yêu cầu đang chờ',
  'bmsg.newReq': 'Tạo yêu cầu',
  'bmsg.notFound': 'Không tìm thấy thư',
  'bmsg.notFoundDesc': 'Message-ID không có trong hộp thư info@. Thư cũ cần tìm trên server.',
  'bmsg.backList': 'Về danh sách yêu cầu',
  'bmsg.mailLabel': 'Nội dung thư',
  'bmsg.type': 'Loại {t} · {name} · hạn {due}',
  'bmsg.mailOps': 'Thao tác thư',
  'bmsg.openedFrom': 'Mở từ việc / thông báo',
  'bmsg.attLabel': 'Tệp đính kèm',
  'bmsg.view': 'Xem {name}',
  'bmsg.attOps': 'Thao tác với {name}',
  'bmsg.files': '{n} tệp',
  'bmsg.dlAll': 'Tải tất cả',
  'bmsg.upload': 'Upload vào job',
  'bmsg.stamp': 'Đóng mộc + ký',
  'bmsg.reply': 'Trả lời',
  'bmsg.moreMail': 'Thao tác khác với thư',
  'bmsg.noWrite': 'Chưa mở ghi ở bản này',
});
addMessages('en', {
  'bmsg.viewLabel': 'View · keys 1 / 2',
  'bmsg.tabReq': 'Requests 5',
  'bmsg.tabVessel': 'Vessels 6',
  'bmsg.coordGroup': 'Shared mailbox coordinator',
  'bmsg.coord': 'Coordinator',
  'bmsg.schedule': 'Schedule',
  'bmsg.scheduleTip': 'Mon–Sat rotation schedule',
  'bmsg.title': 'Booking requests',
  'bmsg.load': 'BKG load',
  'bmsg.tasks': 'Tasks',
  'bmsg.notif': 'Notifications',
  'bmsg.more': 'More actions',
  'bmsg.bulkRod': 'Bulk send ROD',
  'bmsg.bulkRodTip': 'Send ROD for pending requests',
  'bmsg.newReq': 'New request',
  'bmsg.notFound': 'Mail not found',
  'bmsg.notFoundDesc': 'This Message-ID is not in the info@ mailbox. Older mail must be searched on the server.',
  'bmsg.backList': 'Back to request list',
  'bmsg.mailLabel': 'Mail content',
  'bmsg.type': 'Type {t} · {name} · due {due}',
  'bmsg.mailOps': 'Mail actions',
  'bmsg.openedFrom': 'Opened from task / notification',
  'bmsg.attLabel': 'Attachments',
  'bmsg.view': 'View {name}',
  'bmsg.attOps': 'Actions for {name}',
  'bmsg.files': '{n} files',
  'bmsg.dlAll': 'Download all',
  'bmsg.upload': 'Upload to job',
  'bmsg.stamp': 'Stamp + sign',
  'bmsg.reply': 'Reply',
  'bmsg.moreMail': 'More mail actions',
  'bmsg.noWrite': 'Write is not enabled in this build',
});
